import React from 'react';
import '../../../resources/assets/styles/loading.scss';

function Loading(props) {
    return (
        <div id="component-pre-loading">
            <div id="pre-loading"></div>
            <div id="text-pre-loading">COURSEMOS</div>
        </div>
    );
}

export default Loading;